import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from '../../utils/obj-utils';
import { formStyleConstants } from '../../utils/constants/form-style-constants';

function FormHTML({
    fieldName,
    headerTitle,
    headerText,
    isHidden,
    textClassName
}) {
    const fieldClassName = fieldName || formStyleConstants.fieldHeaderClassName;
    const hasEmptyValues = isEmpty(headerTitle) && isEmpty(headerText);
    return (
        isHidden || hasEmptyValues ?
            null :
            <div className={`field-header ${fieldClassName.toLowerCase()}-field`}>
                <h2 className="title field-header-title">{headerTitle}</h2>
                <div className={`fs-14 field-header-text ${textClassName}`} dangerouslySetInnerHTML={{ __html: headerText }}>
                </div>
            </div >
    );
}

FormHTML.propTypes = {
    fieldName: PropTypes.string,
    isHidden: PropTypes.bool,
    headerTitle: PropTypes.string,
    headerText: PropTypes.string,
    textClassName: PropTypes.string,
};

export default FormHTML;
